import { t } from '../i18n';
export const isGroup = (c) => !!c.isGroupChat;
export const otherUser = (c, meId) => (isGroup(c) ? null : c.users.find((u) => u._id !== meId) || c.users[0]);
export const chatTitle = (c, meId) => (isGroup(c) ? c.chatName : (otherUser(c, meId) || {}).fullname || t("Conversation"));

/** Attachments arrive in two legacy shapes: msg.img_user = { img_user: url, fileType, fileName } or a string url + msg.fileType. */
export const attachmentOf = (m) => {
  const a = m && m.img_user;
  if (!a) return null;
  if (typeof a === 'object') return a.img_user ? { url: a.img_user, type: a.fileType || '', name: a.fileName || 'file' } : null;
  return { url: a, type: m.fileType || '', name: m.fileName || 'file' };
};

export const previewOf = (m, meId) => {
  if (!m) return t("No messages yet");
  if (m.deleted) return t("This message was deleted");
  const who = m.sender && m.sender._id === meId ? 'You: ' : '';
  return who + (attachmentOf(m) ? '📎 Attachment' : (m.content || '').replace(/[*`_]/g, ''));
};

export const EMOJI_ONLY = /^(?:\p{Extended_Pictographic}|‍|️|\s){1,6}$/u;

const PREFS = 'gq-chat-prefs';
export const loadPrefs = () => {
  try {
    return { pinned: [], muted: [], unreadMarks: [], ...(JSON.parse(localStorage.getItem(PREFS)) || {}) };
  } catch (e) {
    return { pinned: [], muted: [], unreadMarks: [] };
  }
};
export const savePrefs = (p) => {
  try {
    localStorage.setItem(PREFS, JSON.stringify(p));
  } catch (e) {
    /* storage unavailable */
  }
};
export const draftKey = (id) => `gq-chat-draft-${id}`;
